export const USER_ROLE_VALUES = ['USER', 'VIP', 'ADMIN', 'SUPER_ADMIN'] as const;
